var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-button',{attrs:{"color":"primary","outlined":""},on:{"click":_vm.openDocument}},[_vm._v(" "+_vm._s(_vm.$t("message.posts.postsGuideBtn"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }